/**
 * A *dumb* component that allows user to input some text.
 */

import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { SendIcon } from "../../lib/icons";
import { ScreenSize } from "../../lib/constants";
import { getIsIAactive } from "../InstantAnswers/selectors";
import { urlConfig } from "../../lib/utils";
import type { GlobalState } from "../../lib/types";

/**
 * Well, not this dumb anymore.
 * A little smarter than a kettle.
 */
class DumbTextInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      textInputValue: props.value || "",
    };
  }

  /**
   * Not the cleanest solution.
   * TODO: there is a bug when you click on the invalid editable field - it's value does not get put in the input field.
   */
  componentWillReceiveProps(nextProps) {
    this.setState({ textInputValue: nextProps.value });
  }

  /**
   * Handler for the text input event.
   * @param e - event.
   */
  onTextInput = (e) => {
    const { onChange } = this.props;
    const textInputValue = e.target.value;
    if (window.spaceBarHijacked && (e.code === "Space" || e.which === 32 || e.keyCode === 32)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      this.setState({ textInputValue: `${textInputValue} ` });
    } else {
      this.setState({ textInputValue });
    }
    onChange && onChange(textInputValue);
  };

  /**
   * Handle Enter pressed in the text field.
   * @param e
   */
  onTextInputKeyPress = (e) => {
    const { onSubmit, onChange } = this.props;
    let textInputValue = e.target.value;
    if (window.spaceBarHijacked && (e.code === "Space" || e.which === 32 || e.keyCode === 32)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      textInputValue = `${textInputValue} `;
      this.setState({ textInputValue });
      onChange && onChange(textInputValue);
    }

    if (e.which === 13 || e.keyCode === 13 || e.key === "Enter") {
      this.setState({ textInputValue: "" }); // Should come before `onSubmit`.
      onSubmit(textInputValue);
    }
  };

  onIconClick = () => {
    const { onSubmit, disabled } = this.props;
    if (!disabled) {
      const { textInputValue } = this.state;
      onSubmit(textInputValue);
      this.setState({ textInputValue: "" });
    }
  };

  render() {
    const {
      showSendIcon = true,
      children,
      autoComplete,
      onRef,
      placeholder = "Type here...",
      onClick,
      isIAactive,
    } = this.props;

    const { textInputValue } = this.state;
    const iconClassName = textInputValue ? "send-btn has-value" : "send-btn";

    const sendIcon = showSendIcon ? (
      <div className={iconClassName} onClick={this.onIconClick}>
        <SendIcon fillColor={textInputValue ? "#387BFF" : "#C2D6F1"} />
      </div>
    ) : null;

    let wrapperClassName = "";
    if (isIAactive) {
      wrapperClassName += " ia";
    }
    if (urlConfig.noCaret) {
      wrapperClassName += " no-caret";
    }

    return (
      <TextInputContainer className={wrapperClassName}>
        <div className="inner-container">
          <input
            type="text"
            placeholder={placeholder}
            value={textInputValue || ""}
            onChange={this.onTextInput}
            onKeyDown={this.onTextInputKeyPress}
            ref={onRef}
            autoComplete={autoComplete}
            onClick={onClick}
          />
          {/* SVG does not natively support click events for the testing. Need to wrap with a div. */}
          {sendIcon}
        </div>

        {children}
      </TextInputContainer>
    );
  }
}

export const TextInputContainer = styled.div`
  padding: ${window.innerWidth < ScreenSize.mobile ? "7px 16px" : "16px"};

  .inner-container {
    position: relative;
  }

  &.no-caret input {
    caret-color: transparent;
  }

  input {
    font-weight: 300;
    outline: none;
    height: 55px;
    padding-left: 16px;
    padding-right: 50px;
    width: 100%;
    letter-spacing: 0.3px;
    font-size: 16px;
    color: #2c2c2c;
    background: #fff;
    border-radius: 12px;
    border: 2px solid #d5e2f4;
    position: relative;
    transition: all 0.2s;

    ::placeholder {
      color: rgba(0, 0, 0, 0.4);
      font-size: 14px;
    }

    &:hover {
      border-color: #add0ff;
    }

    &:focus {
      border-color: #a5cbff;
    }
  }

  .send-btn {
    position: absolute;
    top: 18px;
    bottom: 0;
    right: 20px;
    transition: all 0.3s ease-in-out;

    &.has-value {
      cursor: pointer;
    }
  }
`;

/**
 * Damn it, need to make it smarter to look nicer.
 */
function mapStateToProps(state: GlobalState, ownProps) {
  return {
    ...ownProps,
    isIAactive: getIsIAactive(state),
  };
}

export default connect(mapStateToProps)(DumbTextInput);
